import { Box, Chip, Link as MuiLink, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/utils/constants'
import { formatLessonClock } from '@/utils/date'
import { EmptyHint } from './EmptyHint'

interface LessonRow {
  id: number
  planned_start_at: string | null
  status: string
  participants?: Array<{ user?: { display_name?: string } | null }>
}

interface LessonListWidgetProps {
  lessons: LessonRow[]
  emptyKey: string
  /** Формат даты: только время (сегодня) или день+время (неделя) */
  withDate?: boolean
}

const STATUS_COLOR: Record<string, 'default' | 'success' | 'warning'> = {
  planned: 'default',
  in_progress: 'warning',
  completed: 'success',
}

/** Общий список уроков для today_schedule / next_lessons */
export function LessonListWidget({ lessons, emptyKey, withDate = false }: LessonListWidgetProps) {
  const { t } = useTranslation()

  if (lessons.length === 0) {
    return <EmptyHint fallbackKey={emptyKey} />
  }

  return (
    <Stack spacing={1}>
      {lessons.map((lesson) => {
        const participantNames = (lesson.participants ?? [])
          .map((participant) => participant.user?.display_name)
          .filter(Boolean)
          .join(', ')

        return (
          <Box key={lesson.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
            <Typography variant="body2" fontWeight={600} sx={{ whiteSpace: 'nowrap' }}>
              {formatLessonClock(lesson.planned_start_at, { withDate })}
            </Typography>
            <MuiLink
              component={Link}
              to={ROUTES.LESSON_DETAILS(lesson.id)}
              variant="body2"
              noWrap
              sx={{ flexGrow: 1, minWidth: 0 }}
            >
              {participantNames || `#${lesson.id}`}
            </MuiLink>
            <Chip
              size="small"
              label={t(`lessons.status.${lesson.status}`, { defaultValue: t('common.unknown') })}
              color={STATUS_COLOR[lesson.status] ?? 'default'}
            />
          </Box>
        )
      })}
    </Stack>
  )
}
